// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rounded-box[data-v-62593f04]{align-items:center;background-color:#209cee;border-radius:6px;min-height:72px;margin:20px 16px 20px 20px;padding:26px;grid-gap:.5rem;gap:.5rem}.label[data-v-62593f04]{font-style:normal;font-weight:400;font-size:16px;line-height:24px;color:#fff}.label .bold[data-v-62593f04]{font-weight:700}.button-invitation-alert-message[data-v-62593f04]{color:#fff;border:1px solid #fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
